require('./angular');
module.exports = angular;



// WEBPACK FOOTER //
// ./~/ng-admin/~/angular/index.js